import isRequired from './isRequired';
import getValidator from './getValidator';

const isRequiredIf = (config) => (value) => {
  const validator = getValidator(config.validator);
  if (validator({ ...config, value: config.validatorValue })(config.value) === null) {
    return isRequired(config)(value);
  }
  return null;
};

export default isRequiredIf;
